<template>
    <v-layout class="d-flex justify-center align-center" style="height: 70vh;">
        <v-card class="py-5" elevation="3" min-width="540px">
            <v-card-title><h2>Available Portals</h2></v-card-title>

            <v-card-text>
                <v-row v-if="portals.length" class="d-flex justify-center">
                    <v-col v-for="portal in portals" cols="12" md="6">
                        <v-card
                            class="cursor-pointer"
                            elevation="3"
                            @click="switchPortal(portal.type)">
                            <template v-slot:title>
                                <h3 class="text-capitalize">{{ portal.name }}</h3>
                            </template>
                            <template v-slot:text>
                                Open the {{ portal.name }} portal in a new tab.
                            </template>
                        </v-card>
                    </v-col>
                </v-row>

                <v-progress-circular
                    v-else
                    :size="40"
                    :width="5"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script setup>
import {onMounted} from "vue"
import {send} from '@/composables/apiClient'
import {useAuthStore} from '@/stores/authStore'
import {useNavigation} from '@/composables/globals'
import {useSnackbarStore} from '@/stores/snackBarStore'

const auth = useAuthStore()
const snackbar = useSnackbarStore()
const {navigateTo} = useNavigation()
const portals = auth.isAuthenticated() ? auth.portals : []

onMounted(() => {
    if (!auth.isAuthenticated() && !portals.length) {
        send('post', 'sso')
            .then(async (response) => {
                if (response.data.success) {
                    auth.login(response.data.data);
                    if (response.data.data.user.email_verified_at === null) {
                        navigateTo('verify-email', {user: response.data.data.user.id});
                    } else {
                        // Hydrate the circle-gate flags before showing the app so
                        // a minor in circle limbo doesn't flash the full dashboard.
                        await auth.hydrateProfile();
                        navigateTo('dashboard');
                    }
                } else {
                    snackbar.showSnackbar(response.data.message ?? "Something went wrong", 'error')
                    return navigateTo('login');
                }
            })
            .catch((error) => {
                snackbar.showSnackbar("Something went wrong", 'error')
                return navigateTo('login')
            })
    }
})
const switchPortal = (portal) => {
    // Open a blank page immediately to ensure the new tab is opened
    const newTab = window.open("", "_blank");

    send('post', `switch-portal/${portal}`)
        .then((response) => {
            if (response.data.success) {
                // Update the blank page's location to the desired URL
                newTab.location.href = `${response.data.data.url}`;
            } else {
                snackbar.showSnackbar(response.data.message ?? 'Something went wrong', 'error');
                // Close the tab if the operation fails
                newTab.close();
            }
        })
        .catch((error) => {
            snackbar.showSnackbar(error.response?.data?.message ?? 'Something went wrong', 'error');
            // Close the tab if an error occurs
            newTab.close();
        });
}
</script>
